import { Box } from '@mui/material';

const lightningBoltIconBase64 =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjg4MDEgOC40NTUzNEgxNy43MTVDMTcuOTQ2MSA4LjQ1NTM0IDE4LjA4MDggOC43MTk2OCAxNy45NDY4IDguOTEwNDNMOS41NDEgMjAuODc3M0M5LjM1NjU0IDIxLjEzOTkgOC45NTAzNSAyMC45NDQ2IDkuMDM0ODEgMjAuNjMzOUwxMS4zMDYgMTIuMjgwNEg3LjI4NDc2QzcuMDg5MjUgMTIuMjgwNCA2Ljk1MTk5IDEyLjA4NTMgNy4wMTU4MiAxMS44OTgyTDkuOTg1MTUgMy4xOTQwNEMxMC4wMjQ4IDMuMDc3OTEgMTAuMTMyNyAzIDEwLjI1NDEgM0gxNi4zMjMzQzE2LjUzODkgMyAxNi42NzYyIDMuMjMzNDUgMTYuNTczNCAzLjQyNTQyTDEzLjg4MDEgOC40NTUzNFoiIGZpbGw9IiMyRjJBMkEiLz4KPC9zdmc+Cg==';

type LightningBoltIconProps = {
  backgroundColor?: string;
};

export const LightningBoltIcon = ({
  backgroundColor = 'text.secondary',
}: LightningBoltIconProps): JSX.Element => (
  <Box
    sx={{
      width: 16,
      height: 16,
      backgroundColor,
      maskImage: `url(${lightningBoltIconBase64})`,
      maskRepeat: 'no-repeat',
      maskSize: 'contain',
      maskPosition: 'center',
    }}
  />
);
